<template>
	<button
		class="bg-transparent cursor-pointer"
		:class="
			textSize === 'm'
				? 'text-body-m text-neutral-800'
				: 'text-body-xl text-neutral-700 font-underline'
		"
		@click="openDatesDialog"
	>
		<span v-if="formattedDates">{{ formattedDates }}</span>
		<span v-else>{{ $t('Common_Adddates') }}</span>
	</button>
</template>

<script setup lang="ts">
	import { computed, onMounted } from 'vue'
	import { useI18n } from 'vue-i18n'
	import { Itinerary2 } from '~/models/Itinerary'
	import Calendar from '~/passporter-services/shared/calendar'
	import { DialogBuilder, DialogController } from '../../passporterUi/Dialog/dialogController'
	import AddDatesDialog from '~/components/shared/AddDatesDialog.vue'

	interface Props {
		trip: Itinerary2
		isXS: boolean
		textSize?: 'l' | 'm'
	}
	const props = defineProps<Props>()
	const emit = defineEmits(['change-dates'])

	const { locale } = useI18n()

	const calendar = new Calendar(locale.value)
	const datesDialog = createDatesDialog()

	onMounted(() => {
		datesDialog.onAccept(changeDates)
	})

	const formattedDates = computed(() => {
		if (!props.trip.startDate || !props.trip.endDate) return null
		const start = calendar.formatDayMonthToLocale(props.trip.startDate)
		const end = calendar.formatDayMonthToLocale(props.trip.endDate)
		return `${start} - ${end}`
	})

	const calendarDates = computed(() => {
		if (!props.trip.startDate || !props.trip.endDate) return
		return [Calendar.getDateUTC(props.trip.startDate), Calendar.getDateUTC(props.trip.endDate)]
	})

	const openDatesDialog = () => {
		datesDialog.open({ dates: calendarDates, isXS: props.isXS })
	}

	const changeDates = (e: any) => {
		emit('change-dates', e)
	}

	function createDatesDialog() {
		const setup = new DialogBuilder(AddDatesDialog)
			.borderless()
			.size('s')
			.mobileType('fullScreen')
			.build()
		return new DialogController(setup)
	}
</script>

<style scoped lang="scss"></style>
